import { useState } from 'react'
import { Edit } from '@mui/icons-material'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
} from '@mui/material'
import { useElementLabel } from '@editorHooks'
import { FileList, UploadForm } from '@editorComponents'

interface Props {
  itemGuid: string
}

const DocumentationItem = ({ itemGuid }: Props) => {
  const [modalOpen, setModalOpen] = useState(false)

  const getLabel = useElementLabel()

  return (
    <>
      <Stack spacing={1}>
        <FileList itemGuid={itemGuid} />

        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button
            variant="contained"
            color="primary"
            startIcon={<Edit />}
            size="small"
            onClick={() => setModalOpen(true)}
          >
            Bearbeiten
          </Button>
        </Stack>
      </Stack>

      <Dialog open={modalOpen} onClose={() => setModalOpen(false)} maxWidth="lg" fullWidth>
        <DialogTitle>Dokumente für {getLabel(itemGuid)}</DialogTitle>
        <DialogContent>
          <Stack direction="row" spacing={2}>
            <UploadForm itemGuid={itemGuid} />

            <Divider orientation="vertical" flexItem />

            <FileList itemGuid={itemGuid} />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            onClick={() => setModalOpen(false)}
          >
            Schließen
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default DocumentationItem
